import * as yup from 'yup';
import { IFormSelectOption } from '../../../interfaces/forms/forms';

export interface IStepInfoAboutDamage {
	reporterName: string;
	damageType: string;
	whoFillsOut: IFormSelectOption;
	emailForCopyOfReport: string;
	howToHandle: IFormSelectOption;
	trackingNumber: string;
	content: string;
	description: string;
	addReceipts: readonly any[];
	addPictures: readonly any[];
}

export const stepInfoAboutDamageInitialValues: IStepInfoAboutDamage = {
	reporterName: '',
	damageType: '',
	whoFillsOut: null,
	emailForCopyOfReport: '',
	howToHandle: null,
	trackingNumber: '',
	content: '',
	description: '',
	addReceipts: new Array<any>(),
	addPictures: new Array<any>(),
};

const yupFormSelectOption = {
	label: yup.string(),
	value: yup.string(),
};

export const stepInfoAboutDamageSchema = yup.object().shape({
	reporterName: yup.string().when('whoFillsOut', {
		is: val => (val ? val.value === 'other' : false),
		then: yup.string().required('required'),
	}),
	whoFillsOut: yup.object().nullable().shape(yupFormSelectOption).required('required'),
	emailForCopyOfReport: yup.string().when('whoFillsOut', {
		is: val => (val ? val.value === 'employee' : false),
		then: yup.string().email('emailNotValid').required('emailRequired'),
		otherwise: yup.string(),
	}),
	howToHandle: yup
		.object()
		.nullable()
		.when('damageType', {
			is: val => val === 'reportDamage',
			then: yup.object().shape(yupFormSelectOption).required('required'),
		}),
	trackingNumber: yup
		.string()
		.min(8, 'trackingnumberMin')
		.max(35, 'trackingnumberMax')
		//.matches(/^[a-zA-Z]{2}[0-9]{9}[0-9a-zA-Z]{2}$/, 'trackingnumberWrong')
		.required('required'),
	content: yup.string().required('required'),
	description: yup.string().required('required').max(1024, 'tooLong'),
	addReceipts: yup.array().nullable().required('required'),
	addPictures: yup
		.array()
		.nullable()
		.when('damageType', {
			is: val => val === 'reportDamage',
			then: yup.array().required('required'),
		}),
});
